var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailSendEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.81858 6.71713C5.16627 6.40964 5.62012 6.25 6.07692 6.25H17.9231C18.3799 6.25 18.8337 6.40965 19.1814 6.71713C19.5321 7.02724 19.75 7.46906 19.75 7.95238V16.0476C19.75 16.5309 19.5321 16.9728 19.1814 17.2829C18.8337 17.5904 18.3799 17.75 17.9231 17.75H6.07692C5.62012 17.75 5.16626 17.5904 4.81858 17.2829C4.4679 16.9728 4.25 16.5309 4.25 16.0476V7.95238C4.25 7.46906 4.4679 7.02725 4.81858 6.71713ZM6.07692 7.75C5.96249 7.75 5.86851 7.79103 5.81227 7.84077C5.75902 7.88786 5.75 7.93053 5.75 7.95238V16.0476C5.75 16.0695 5.75902 16.1121 5.81227 16.1592C5.86851 16.209 5.96249 16.25 6.07692 16.25H17.9231C18.0375 16.25 18.1315 16.209 18.1877 16.1592C18.241 16.1121 18.25 16.0695 18.25 16.0476V7.95238C18.25 7.93053 18.241 7.88786 18.1877 7.84077C18.1315 7.79103 18.0375 7.75 17.9231 7.75H6.07692Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35852 7.61139C4.57314 7.25712 5.03433 7.14391 5.3886 7.35854L11.6955 11.1794C11.759 11.2164 11.8658 11.25 12 11.25C12.1342 11.25 12.241 11.2164 12.3044 11.1794L18.6114 7.35854C18.9657 7.14391 19.4268 7.25712 19.6415 7.61139C19.8561 7.96567 19.7429 8.42685 19.3886 8.64147L13.0719 12.4682C12.7474 12.6607 12.3683 12.75 12 12.75C11.6317 12.75 11.2526 12.6607 10.9281 12.4682L10.9221 12.4647L4.61138 8.64147C4.2571 8.42685 4.1439 7.96567 4.35852 7.61139Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSendEnvelope);
export default __webpack_public_path__ + "static/media/Mail Send Envelope.702c939cc72ac4953b05fb1be457aa05.svg";
export { ForwardRef as ReactComponent };